import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText);
import flipbutton from '../snippets/flipbutton'

export default class PageIntro {
    constructor(container) {
        this.container = container;
        this.lead = this.container.querySelector('.page-intro__lead');
        this.callout = this.container.querySelector('.page-intro__callout');
        this.columns = this.container.querySelectorAll('.page-intro__column');
        this.flipbuttons = this.container.querySelectorAll('.js-flipbutton');

        this.init();
    }

    init = () => {
        if (this.lead) {
            const split = new SplitText(this.lead, { type: 'words' });

            gsap.fromTo(
                split.words,
                { opacity: 0 },
                {
                    opacity: 1,
                    duration: 0.6,
                    ease: 'power2.out',
                    stagger: { each: 0.01, from: 'random' },
                    scrollTrigger: {
                        trigger: this.lead,
                        start: 'top 85%',
                    },
                    onComplete: () => split.revert(),
                }
            );
        }

        if (this.callout) {
            gsap.fromTo(
                this.callout,
                { opacity: 0, x: 40 },
                {
                    opacity: 1,
                    x: 0,
                    duration: 0.8,
                    delay: 1,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: this.callout,
                        start: 'top 85%',
                    },
                }
            );
        }

        this.columns.forEach((column) => {
            let revealed = false;
            const unmask = (split) => split.masks.forEach((mask) => (mask.style.overflow = 'visible'));

            // Split each paragraph (the column's only child is the <p>) after the webfont
            // loads (autoSplit). The lines are kept after the reveal: reverting re-wraps
            // the text slightly differently and makes it jump. aria: 'none' keeps the
            // lines (and the mailto link) readable; unmask stops clipping focus rings.
            SplitText.create(column.children, {
                type: 'lines',
                mask: 'lines',
                aria: 'none',
                autoSplit: true,
                onSplit: (self) => {
                    if (revealed) return unmask(self);

                    return gsap.fromTo(
                        self.lines,
                        { yPercent: 100 },
                        {
                            yPercent: 0,
                            duration: 0.8,
                            ease: 'power3.out',
                            stagger: { each: 0.06, from: 'start' },
                            scrollTrigger: {
                                trigger: column,
                                start: 'top 85%',
                                once: true,
                            },
                            onComplete: () => {
                                revealed = true;
                                unmask(self);
                            },
                        }
                    );
                },
            });
        });

        this.flipbuttons.forEach(element => {
            new flipbutton(element);
        });
    };
}
